import { render } from "./RiskChat.vue?vue&type=template&id=6c71ce7f&scoped=true"
import script from "./RiskChat.vue?vue&type=script&lang=js"
export * from "./RiskChat.vue?vue&type=script&lang=js"

import "./RiskChat.vue?vue&type=style&index=0&id=6c71ce7f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c71ce7f"]])

export default __exports__